// Copyright TraderEvolution Global LTD. © 2017-2026. All rights reserved.
import TerceraGroupPanelTemplate from '@front/templates/TerceraGroupPanelTemplate.html';
import { ContainerControl } from './ContainerControl';
export class TerceraGroupPanel extends ContainerControl {
    constructor() {
        super();
    }
    getType() {
        return 'TerceraGroupPanel';
    }
    getClientPanel(customPlace) {
        void this.set('showRightContainer', customPlace);
        if (customPlace) {
            return this.find('.js-group-panel-right-container');
        }
        else {
            return this.find('.js-group-panel-left-container');
        }
    }
}
ContainerControl.extendWith(TerceraGroupPanel, {
    template: TerceraGroupPanelTemplate
});
